var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlertIcon = function SvgAlertIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 19 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FB3",
    fillRule: "evenodd",
    d: "M8.144.703c.585-.938 1.536-.937 2.121 0l7.879 12.605c.585.938.162 1.697-.93 1.697H1.195c-1.1 0-1.515-.76-.93-1.697zm.06 3.302v6h2v-6zm0 7v2h2v-2z"
  })));
};
export default SvgAlertIcon;